import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiSearchparticipantCreateElectionMutationRequest,
  PostApiSearchparticipantCreateElectionMutationResponse,
} from "../../../types/PostApiSearchparticipantCreateElection";

export function getPostApiSearchparticipantCreateElectionUrl() {
  return `/api/SearchParticipant/create-election` as const;
}

/**
 * {@link /api/SearchParticipant/create-election}
 */
export async function postApiSearchparticipantCreateElection(
  data?: PostApiSearchparticipantCreateElectionMutationRequest,
  config: Partial<
    RequestConfig<PostApiSearchparticipantCreateElectionMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiSearchparticipantCreateElectionMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiSearchparticipantCreateElectionMutationRequest
  >({
    method: "POST",
    url: getPostApiSearchparticipantCreateElectionUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
